import React, {FC, PropsWithChildren} from 'react';

import {makeDesktopPushEventSubscriptions} from '../../../../../srcCommon/push/desktopPushEventSubscriptions';
import {PushContentRefresher, RawBootHandler} from '../../../../../srcCommon/push/v2/pushContentRefresher';
import {PushControllerProviderContainer} from '../../../../../srcCommon/push/v2/pushControllerProviderContainer';
import {PushGlobalEventHandlersContainer} from '../../../../../srcCommon/push/v2/pushGlobalEvents';
import {PushPresenceEvents} from '../../../../../srcCommon/push/v2/pushPresenceEvents';
import {DesktopFailedDraftBanner} from './desktopFailedDraftBanner';
import {DesktopImpersonationRequestBanner} from './desktopImpersonationRequestBanner';
import {DesktopOfflineBanner} from './desktopOfflineBanner';
import {DesktopReconnection} from './desktopReconnection';

interface DesktopPushProps {
  onRawBoot: RawBootHandler;
}

export const DesktopPush: FC<PropsWithChildren<DesktopPushProps>> = ({children, onRawBoot}) => (
  <PushControllerProviderContainer>
    <PushGlobalEventHandlersContainer makePushEventSubscriptions={makeDesktopPushEventSubscriptions} />
    <PushPresenceEvents />
    <DesktopImpersonationRequestBanner />
    <DesktopFailedDraftBanner />
    <DesktopOfflineBanner />
    <DesktopReconnection />
    <PushContentRefresher onRawBoot={onRawBoot}>{children}</PushContentRefresher>
  </PushControllerProviderContainer>
);
